import router from "../../shared/router";
import {store} from './../../plugins/vuex/index'

const authService = {
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  loggedIn() {
    return !!localStorage.getItem('AUTH_TOKEN');
  },
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  async logout() {
    await store.dispatch('global/logoutCallback')
    localStorage.removeItem('AUTH_TOKEN');
    await router.push('/login');
  },
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   * @returns {string}
   */
  getToken() {
    return localStorage.getItem('AUTH_TOKEN');
  },
  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  setToken(value) {
    return localStorage.setItem('AUTH_TOKEN', value);
  },
  getRememberDevice(key) {
    return localStorage.getItem(key);
  },
  setRememberDevice(key, value) {
    return localStorage.setItem(key, value);
  },
};

export default authService;
